import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BulkEditSectionFormService, ZagSwitch } from '@zag/ui';

const SECTION_ID = 'bulk-role-assignable';

interface State {
  assignableToPositions: boolean;
}

@Component({
  selector: 'sc-role-assignable-bulk-section',
  template: `
    <div class="role-assignable-bulk-section">
      <zag-switch
        [checked]="state().assignableToPositions"
        [ariaLabel]="'bulkEdit.roles.assignable.ariaLabel' | translate"
        (checkedChange)="onChange($event)"
      />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ZagSwitch, TranslatePipe],
})
export class RoleAssignableBulkSectionComponent implements OnInit, OnDestroy {
  private readonly formService = inject(BulkEditSectionFormService);

  protected readonly state = signal<State>({ assignableToPositions: false });

  protected onChange(value: boolean): void {
    this.state.set({ assignableToPositions: value });
  }

  ngOnInit(): void {
    this.formService.register(SECTION_ID, () => this.state());
  }

  ngOnDestroy(): void {
    this.formService.unregister(SECTION_ID);
  }
}
